import React from "react";
import LegalPage from "./LegalPage";
import { LEGAL } from "./legalData";

const PoliticaPrivacidad = () => (
  <LegalPage title="Política de Privacidad" lastUpdated={LEGAL.lastUpdated}>
    <h2>1. Responsable del tratamiento</h2>
    <ul>
      <li><strong>Responsable:</strong> {LEGAL.razonSocial} (sociedad constituida en {LEGAL.paisRegistro})</li>
      <li><strong>Número de sociedad (Companies House):</strong> {LEGAL.numeroSociedad}</li>
      <li><strong>Domicilio social:</strong> {LEGAL.domicilio}</li>
      <li><strong>Contacto:</strong> {LEGAL.emailPrivacidad}</li>
      {LEGAL.dpoEmail && <li><strong>Delegado de Protección de Datos (DPO):</strong> {LEGAL.dpoEmail}</li>}
    </ul>

    <h2>2. Datos que tratamos</h2>
    <p>Según tu relación con nosotros, podemos tratar las siguientes categorías de datos:</p>
    <ul>
      <li><strong>Datos de la cuenta:</strong> nombre, correo electrónico y credenciales de acceso.</li>
      <li><strong>Datos de facturación:</strong> datos necesarios para gestionar la suscripción y los pagos (procesados por Stripe).</li>
      <li><strong>Datos operativos del club (introducidos por el cliente):</strong> información de socios, inventario, transacciones y documentación asociada (por ejemplo, fotografías y documentos de identidad de socios), tratada por cuenta del cliente.</li>
      <li><strong>Datos técnicos:</strong> dirección IP, registros de acceso y datos de la sesión, con fines de seguridad y funcionamiento.</li>
    </ul>

    <h2>3. Finalidades y base jurídica</h2>
    <table className="legal-table">
      <thead>
        <tr><th>Finalidad</th><th>Base jurídica (RGPD art. 6)</th></tr>
      </thead>
      <tbody>
        <tr><td>Prestar y gestionar el Servicio y tu cuenta</td><td>Ejecución del contrato</td></tr>
        <tr><td>Gestionar suscripciones, pagos y facturación</td><td>Ejecución del contrato / obligación legal</td></tr>
        <tr><td>Seguridad, prevención del fraude y registros de acceso</td><td>Interés legítimo</td></tr>
        <tr><td>Atención al usuario y soporte</td><td>Ejecución del contrato / interés legítimo</td></tr>
        <tr><td>Comunicaciones comerciales (si procede)</td><td>Consentimiento</td></tr>
      </tbody>
    </table>

    <h2>4. Rol respecto a los datos de los socios del club</h2>
    <p>
      Respecto de los datos que el cliente (el club) introduce sobre sus socios, {LEGAL.razonSocial}
      actúa como <strong>encargado del tratamiento</strong> y el club como responsable. El tratamiento
      se rige por el correspondiente contrato de encargado (RGPD art. 28).
    </p>

    <h2>5. Destinatarios y encargados de tratamiento</h2>
    <p>No vendemos tus datos. Compartimos datos únicamente con proveedores que nos prestan servicios:</p>
    <table className="legal-table">
      <thead>
        <tr><th>Proveedor</th><th>Finalidad</th><th>Ubicación</th></tr>
      </thead>
      <tbody>
        {LEGAL.encargados.map((e) => (
          <tr key={e.nombre}>
            <td>{e.nombre}</td>
            <td>{e.finalidad}</td>
            <td>{e.ubicacion}</td>
          </tr>
        ))}
      </tbody>
    </table>

    <h2>6. Transferencias internacionales</h2>
    <p>
      Cuando algún proveedor trate datos fuera del Espacio Económico Europeo, dichas transferencias
      se amparan en garantías adecuadas conforme al RGPD (por ejemplo, cláusulas contractuales tipo de
      la Comisión Europea).
    </p>

    <h2>7. Plazo de conservación</h2>
    <p>
      Conservamos los datos mientras se mantenga la relación contractual y, posteriormente, durante los
      plazos legalmente exigibles (por ejemplo, obligaciones fiscales y contables). Después se suprimen
      o anonimizan.
    </p>

    <h2>8. Tus derechos</h2>
    <p>
      Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del
      tratamiento y portabilidad escribiendo a {LEGAL.emailPrivacidad}. Asimismo, tienes derecho a
      presentar una reclamación ante la Agencia Española de Protección de Datos (
      <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>).
    </p>

    <h2>9. Seguridad</h2>
    <p>
      Aplicamos medidas técnicas y organizativas apropiadas para proteger los datos (cifrado en
      tránsito y en reposo, control de accesos y registros de seguridad), conforme al artículo 32 del
      RGPD.
    </p>
  </LegalPage>
);

export default PoliticaPrivacidad;
